import React, { useState, useEffect } from "react";
import Dashboard from "./components/Dashboard";
import ProjectWizard from "./components/ProjectWizard";
import ProjectSummary from "./components/ProjectSummary";
//import SubscriptionManagement from "./components/SubscriptionManagement";
import Layout from "./components/Layout";
import Home from "./components/Home";
import { Analytics } from '@vercel/analytics/react';

const validPages = ["home", "dashboard", "wizard", "summary"];

const App = () => {
    const storedPage = localStorage.getItem("currentPage");
    const storedSubscription = localStorage.getItem("isSubscribed") === "true";

    const [currentPage, setCurrentPage] = useState(
        storedSubscription && validPages.includes(storedPage) ? storedPage : "home"
    );

    // const navigateToPage = (page) => {
    //     if (validPages.includes(page)) {
    //         setCurrentPage(page);
    //     }
    // };

    const navigateToPage = (page) => {
        if (validPages.includes(page)) {
            setCurrentPage(page);
            localStorage.setItem("currentPage", page);
            setFormData((prev) => ({ ...prev, currentPage: page })); // Save to formData
        }
    };


    const [isSubscribed, setIsSubscribed] = useState(storedSubscription);

    const [formData, setFormData] = useState({
        projectName: '',
        startDate: '',
        budget: '',
        estimatedHours: '',
        implementationType: '',

        preferredResources: [ // ✅ Matches JSON format
            { name: "", hourlyRate: 0, count: 0 }
        ],

        techStack: [],

        sprintsMilestones: [ // ✅ Enhanced Sprint Details
            {
                name: "",
                duration: 0,
                startDate: "",   // ✅ Sprint Start Date
                endDate: "",     // ✅ Sprint End Date
                actualStartDate: "",   // ✅ Sprint Start Date
                actualEndDate: "",     // ✅ Sprint End Date
                totalAllocatedHours: 0,  // ✅ Total hours allocated for this sprint
                totalBandwidthHours: 0,  // ✅ Bandwidth hours available
                workingDays: 0,   // ✅ Actual working days (excluding weekends/holidays)
                utilizationRate: 0, // ✅ % of hours utilized
                sprintCost: 0,    // ✅ Cost of sprint (resources only)
                holidays: []
            }
        ],

        projectExpenses: [ // ✅ Matches JSON format for expenses
            { item: "", manufacturer: "", description: "", quantity: 0, unitPrice: 0, totalCost: 0 }
        ],

        industry: '',
        comments: '',
        stateTax: '',
        isFBTechStack: true,
        currentStep: 1,
        currentPage: 'dashboard', // ✅ Tracks navigation

        // ✅ New Fields for Summary & Report
        estimatePreparedBy: '',  // ✅ Name of the person who prepared the estimate
        estimatePreparedFor: '', // ✅ Name of the client/company for whom the estimate is prepared
        termsAndConditions: '',  // ✅ Terms & conditions for the estimate
        weekendDays: [],   // ✅ Array of weekend days (e.g., ["Saturday", "Sunday"])
        holidays: [],   // ✅ List of holidays that affect business days

        // ✅ New Fields for Cost Breakdown
        totalProjectCost: 0,  // ✅ Sum of all resource & material costs
        costBreakdownByResource: [ // ✅ Breakdown by resource
            { resource: "", cost: 0 }
        ],
        businessHoursPerDay: 8,
        totalResourceCount: 0,
        allocationMatrix: [],
        resourceTable: [] // ✅ Total number of resources used in the project
    });



    const [returnToReview, setReturnToReview] = useState(false);

    useEffect(() => {
        if (validPages.includes(currentPage)) {
            localStorage.setItem("currentPage", currentPage);
        }
        //console.log("Rendering Page:", currentPage);
    }, [currentPage]);

    const handleSubscriptionSuccess = () => {
        setIsSubscribed(true);
        localStorage.setItem("isSubscribed", "true");
        setCurrentPage("dashboard");
    };

    const handleLogout = () => {
        localStorage.clear();
        setIsSubscribed(false);
        setCurrentPage("home");
        window.location.reload();
    };

    return (
        <Layout>
            {!isSubscribed && <Home onSubscriptionSuccess={handleSubscriptionSuccess} />}

            {isSubscribed && currentPage === "home" && (
                <Home onSubscriptionSuccess={handleSubscriptionSuccess} navigateToPage={navigateToPage} />
            )}

            {/* {isSubscribed && currentPage === "dashboard" && (
                <Dashboard
                    onCreateNewProject={() => setCurrentPage("wizard")}
                    onUploadExistingProject={(data) => {
                        setFormData(data);
                        setCurrentPage("summary");
                    }}
                    onLogout={handleLogout}
                    navigateToPage={navigateToPage}
                    isSubscribed={isSubscribed}
                />
            )} */}

            {isSubscribed && currentPage === "dashboard" && (
                <Dashboard
                    onCreateNewProject={() => setCurrentPage("wizard")}
                    onUploadExistingProject={(data) => {
                        setFormData(data);

                        if (data.currentStep && data.currentPage) {
                            // Navigate to the saved step in wizard or summary
                            setCurrentPage(data.currentPage);
                        } else {
                            // Default to summary if no step info exists
                            setCurrentPage("summary");
                        }
                    }}
                    onLogout={handleLogout}
                    navigateToPage={navigateToPage}
                    isSubscribed={isSubscribed}
                />
            )}


            {isSubscribed && currentPage === "wizard" && (
                <ProjectWizard
                    formData={formData}
                    setFormData={setFormData}
                    onGenerateProjectPlan={() => setCurrentPage("summary")}
                    onGoDashboard={() => setCurrentPage("dashboard")}
                    returnToReview={returnToReview}
                    clearReturnToReview={() => setReturnToReview(false)}
                    navigateToPage={navigateToPage}
                    isSubscribed={isSubscribed}
                />
            )}

            {isSubscribed && currentPage === "summary" && (
                <ProjectSummary
                    formData={formData}
                    setFormData={setFormData}
                    navigateToPage={navigateToPage}
                    isSubscribed={isSubscribed}
                    onBackToReview={() => {
                        setReturnToReview(true);
                        setCurrentPage("wizard");
                    }}
                />
            )}

          



            {isSubscribed && !validPages.includes(currentPage) && (
                <div className="text-center p-6">
                    <h2 className="text-2xl font-bold text-red-500">Oops! Page not found.</h2>
                    <button
                        onClick={() => setCurrentPage("dashboard")}
                        className="bg-blue-500 text-white px-4 py-2 mt-4 rounded-lg">
                        Go to Dashboard
                    </button>
                </div>
            )}
            <Analytics />
        </Layout>
    );
};

export default App;
